// @flow

export const ROLES = {
  collaborator: 'collaborator',
  subscriber: 'subscriber',
  invitee: 'invitee',
};
